var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.767,
    height: 49.1,
    viewBox: "0 0 33.767 49.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_545",
    "data-name": "Group 545",
    transform: "translate(-137.989 169.564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M165.068-120.464H144.676a6.7,6.7,0,0,1-6.687-6.688v-25.607a6.7,6.7,0,0,1,6.687-6.687h20.392a6.7,6.7,0,0,1,6.688,6.687v25.607A6.7,6.7,0,0,1,165.068-120.464Zm-20.392-35.982a3.691,3.691,0,0,0-3.687,3.687v25.607a3.692,3.692,0,0,0,3.687,3.688h20.392a3.692,3.692,0,0,0,3.688-3.688v-25.607a3.691,3.691,0,0,0-3.688-3.687Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M164.411-160.025h-3a6.546,6.546,0,0,0-6.538-6.539,6.547,6.547,0,0,0-6.54,6.539h-3a9.55,9.55,0,0,1,9.54-9.539A9.549,9.549,0,0,1,164.411-160.025Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M146.833-147.107a1.5,1.5,0,0,1-1.5-1.5v-11.418a1.5,1.5,0,0,1,1.5-1.5,1.5,1.5,0,0,1,1.5,1.5v11.418A1.5,1.5,0,0,1,146.833-147.107Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M162.911-147.107a1.5,1.5,0,0,1-1.5-1.5v-11.418a1.5,1.5,0,0,1,1.5-1.5,1.5,1.5,0,0,1,1.5,1.5v11.418A1.5,1.5,0,0,1,162.911-147.107Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.03d81412ecdd7c6061ebd8d783e698e9.svg";
export { ForwardRef as ReactComponent };